import React, { memo, forwardRef } from "react";
const SvgAlphabetQ = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.27 13.61c0 .373.053.747.16 1.12.12.373.293.707.52 1 .227.293.513.533.86.72.347.187.753.28 1.22.28.44 0 .833-.087 1.18-.26a2.9 2.9 0 00.88-.72c.253-.293.44-.62.56-.98.133-.373.2-.747.2-1.12 0-.373-.067-.747-.2-1.12a2.847 2.847 0 00-.56-1 2.9 2.9 0 00-.88-.72 2.449 2.449 0 00-1.18-.28c-.467 0-.873.093-1.22.28a2.458 2.458 0 00-.86.7c-.227.293-.4.627-.52 1-.107.36-.16.727-.16 1.1zm5.5 3.56h-.04c-.307.48-.747.86-1.32 1.14a4.1 4.1 0 01-1.86.42c-.733 0-1.393-.133-1.98-.4a4.875 4.875 0 01-1.48-1.1 5.271 5.271 0 01-.94-1.62 6.162 6.162 0 01-.32-2c0-.707.113-1.367.34-1.98a4.83 4.83 0 01.96-1.6 4.366 4.366 0 011.48-1.06c.573-.267 1.2-.4 1.88-.4.44 0 .833.053 1.18.16.36.093.68.22.96.38.28.147.513.32.7.52.2.187.36.373.48.56h.06v-.24c0-.267.04-.48.12-.64.093-.173.2-.307.32-.4a.914.914 0 01.36-.18c.133-.04.247-.06.34-.06.093 0 .207.02.34.06.133.027.26.087.38.18s.22.227.3.4c.093.16.14.373.14.64v12.14c0 .28-.047.507-.14.68a.954.954 0 01-.32.42.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.2 1.2 0 01-.32-.42c-.08-.173-.12-.4-.12-.68v-4.92z"
      />
    </svg>
  );
});
SvgAlphabetQ.displayName = "SvgAlphabetQ";
const MemoForwardRef = memo(SvgAlphabetQ);
export default MemoForwardRef;
